import {
  GET_DADOS_CNPJ_INIT,
  GET_DADOS_CNPJ_SUCCESS,
  DADOS_EXTERNOS_CLEAN_UP,
  ERROR_DADOS_EXTERNOS_MSG
} from '../actionTypes';

const INIT_STATE = {
  loading: false,
  success: false,
  isError: false,
  msg: '',
  cnpjDados: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_DADOS_CNPJ_INIT:
      return { ...state, loading: true, success: false };

    case GET_DADOS_CNPJ_SUCCESS: {
      const { dados } = action.payload;
      return { ...state, loading: false, success: true, cnpjDados: dados };
    }

    case DADOS_EXTERNOS_CLEAN_UP: {
      return {
        ...state,
        loading: false,
        isError: false,
        success: false,
        msg: '',
        cnpjDados: null
      };
    }

    case ERROR_DADOS_EXTERNOS_MSG: {
      const { msg } = action.payload;
      return {
        ...state,
        loading: false,
        success: false,
        isError: true,
        cnpjDados: null,
        msg
      };
    }

    default:
      return { ...state };
  }
};
